import React from 'react';
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { getTotalAmountAndTotalWeight } from "../../../../pages/PlanOperationPage/util";
import { KeyOfStep, OP_STATUS } from "../../../../util/varibles/constants";
import { formatNumber } from "../../../../util/varibles/global";
import { IOperation2, ITransport2 } from '../../../../util/varibles/interface';
import Icon, { ICON_NAME } from "../../../Icon";
import HarvestingInfo from "../../_components/HarvestingInfo";
import Header from "../../_components/Header";
import Note from "../../_components/Note";
import StepControl from "../../_components/StepControl";
import TabControl from "../../_components/TabControl";
import ActivityLogs from "../../ActivitiesLog/ActivityLogs/ActivityLogs";
import stylesOp from "../style.module.scss";

const Transport: React.FC = () => {
    const [data] = useTrackingOp(state => state.op as IOperation2<ITransport2>);
    const [step] = useTrackingOp(state => state.step);

    if (!data) return null;

    const { status, source, destination, source_name = '', destination_name = '', sub_operations } = data.operation;
    const { name: sourceName = source_name } = source || {};
    const { name: destinationName = destination_name } = destination || {};
    const { total_amount, total_weight } = getTotalAmountAndTotalWeight(sub_operations);
    const { key = '' }: any = data.activity_log[step] || {};

    return <>
        <Header icon={<Icon icon={ICON_NAME.TRANSPORT} />}>
            <div className={[stylesOp['operation-route'], 'flex items-center'].join(' ')}>
                <span>{sourceName}</span>
                <span className='arrow-right' />
                <span>{destinationName}</span>
            </div>
        </Header>
        <TabControl>
            {[
                <div className={stylesOp['operation-info']} key="info">
                    <div className={stylesOp['operation-content']}>
                        <StepControl />
                        {status === OP_STATUS.PROCESSING && <div className={stylesOp['operation-step-content']}>
                            <div>Σ amount, Σ weight: <span
                                className={stylesOp['amount-weight']}>{formatNumber(total_amount)} | {formatNumber(Math.round(total_weight / 1000) / 1000)} t</span>
                            </div>
                            {[KeyOfStep.HARVEST, KeyOfStep.DISCHARGE_FACTORY].includes(key) &&
                                <HarvestingInfo sub_operations={sub_operations} />}
                            <Note />
                        </div>}
                    </div>
                </div>,
                <ActivityLogs key="activity_log" data={data} />
            ]}
        </TabControl>

    </>;
};

export default Transport;